"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewSL = void 0;
function viewSL() {
    return {
        constructor: function (props) { },
        mounted: function () { },
        events: {
            onFileUploadSuccess: this.props.onFileUploadSuccess,
            onFileUploadError: this.props.onFileUploadError,
            onFileDelete: this.props.onFileDelete,
            onAdditionalAttachmentCreate: this.props.onAdditionalAttachmentCreate
        }
    };
}
exports.viewSL = viewSL;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowAdditionalAttachments/ViewSL.js
// module id = 408
// module chunks = 0 2